import { useState, useEffect, useContext } from "react";
import { useForm } from "react-hook-form";

// Context
import { AlertNotificationContext } from "../../contexts/AlertNotificationContext";
// MUI
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Paper from "@mui/material/Paper";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
// Components
import { ReturnInfo } from "./ReturnInfo";
// import { ReturnFormType } from "./ReturnFormType";
import { ReturnFormLines } from "./ReturnFormLines";
import { ReturnCancelButton } from "./ReturnCancelButton";
import { NonReturnableDialog } from "./NonReturnableDialog";
import { ReturnAddress } from "./ReturnAddress";
// import { ReturnSubmitBtn } from "./ReturnSubmitBtn";

import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
dayjs.extend(customParseFormat);

export const ReturnDetails = ({
  returnData,
  setReturnData,
  setActiveStep,
  returnDataOriginal,
}) => {
  const [returnable, setReturnable] = useState(true);
  const { setAlertNotification } = useContext(AlertNotificationContext);

  const { handleSubmit, control, watch, setValue, getValues } = useForm({
    defaultValues: {
      returnOrder: returnData.data.data.returnOrder,
      returnOrderLines: returnData.data.data.returnOrderLines,
    },
  });

  const handleOnSubmit = (data) => {
    // If all returnOrderLines have a qtyOrdered of 0, return
    if (data.returnOrderLines.every((line) => Number(line.qtyOrdered) === 0)) {
      setAlertNotification({
        message: `At least one line must have a quantity greater than 0`,
        severity: "warning",
      });
      return;
    }

    setReturnData((prevState) => ({
      data: {
        data: {
          ...prevState.data.data,
          returnOrder: data.returnOrder,
          returnOrderLines: data.returnOrderLines,
        },
      },
    }));
    setActiveStep(2);
  };

  // Check if returnable
  const isReturnable = (returnByDate) => {
    const now = dayjs();
    const returnDate = dayjs(returnByDate, "DD/MM/YY");
    if (now.isBefore(returnDate, "day")) {
      return true;
    }
  };

  // Check if any of lines are returnable
  useEffect(() => {
    const returnableArray = [];
    returnData.data.data.returnOrderLines.forEach((line) => {
      returnableArray.push(isReturnable(line.returnByDate));
    });
    setReturnable(returnableArray.includes(true));
  }, [returnData.data.data.returnOrderLines]);

  return (
    <Paper sx={{ p: 2 }}>
      <Typography variant="h6" gutterBottom>
        Return - {returnData.data.data.returnOrder.no}
      </Typography>
      <Stack
        spacing={2}
        component="form"
        autoComplete="off"
        onSubmit={handleSubmit(handleOnSubmit)}
      >
        <ReturnInfo returnData={returnData} control={control} />
        {/* <Box>
          <Typography sx={{ pb: 1 }}>Type</Typography>
          <ReturnFormType
            returnData={returnData}
            control={control}
            watch={watch}
          />
        </Box> */}
        <Box sx={{ pt: 0 }}>
          <ReturnAddress
            setReturnData={setReturnData}
            returnData={returnData.data.data.returnOrder}
            setValue={setValue}
            getValues={getValues}
            watch={watch}
          />
        </Box>
        <ReturnFormLines
          returnData={returnData}
          returnDataOriginal={returnDataOriginal}
          control={control}
          setValue={setValue}
          watch={watch}
          getValues={getValues}
        />
        <Stack
          direction="row"
          sx={{
            justifyContent: "space-between",
          }}
        >
          <ReturnCancelButton
            returnData={returnData}
            setReturnData={setReturnData}
            setActiveStep={setActiveStep}
          />

          <Button
            variant="contained"
            type="submit"
            size="large"
            disabled={!returnable}
          >
            Next
          </Button>
        </Stack>
      </Stack>
      {!returnable && (
        <NonReturnableDialog
          returnData={returnData}
          setReturnData={setReturnData}
          setActiveStep={setActiveStep}
          openDialog={!returnable}
        />
      )}
    </Paper>
  );
};
